module.exports = __webpack_public_path__ + "static/media/mail.b590ddaa.svg";